import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { BranchAvatarModule } from '@portal-core/branches/components/branch-avatar/branch-avatar.module';
import { BuildAvatarModule } from '@portal-core/builds/components/build-avatar/build-avatar.module';
import { BuildDeletionFormModule } from '@portal-core/builds/components/build-deletion-form/build-deletion-form.module';
import { BuildOverviewModule } from '@portal-core/builds/components/build-overview/build-overview.module';
import { BuildSettingsFormModule } from '@portal-core/builds/components/build-settings-form/build-settings-form.module';
import { ConfirmDialogModule } from '@portal-core/general/components/confirm-dialog/confirm-dialog.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { MaximizeDialogButtonModule } from '@portal-core/general/components/maximize-dialog-button/maximize-dialog-button.module';
import { PreventDefaultModule } from '@portal-core/general/directives/prevent-default/prevent-default.module';
import { DurationModule } from '@portal-core/general/pipes/duration/duration.module';
import { LogTabPanelModule } from '@portal-core/live-log/components/log-tab-panel/log-tab-panel.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { TargetAvatarModule } from '@portal-core/targets/components/target-avatar/target-avatar.module';
import { SwitchBoardModule } from '@portal-core/ui/switch-board/switch-board.module';
import { BuildProfileDialogComponent } from './build-profile-dialog.component';

@NgModule({
  declarations: [
    BuildProfileDialogComponent
  ],
  imports: [
    BranchAvatarModule,
    BuildAvatarModule,
    BuildDeletionFormModule,
    BuildOverviewModule,
    BuildSettingsFormModule,
    CommonModule,
    ConfirmDialogModule,
    DurationModule,
    ErrorsExpansionPanelModule,
    LoaderModule,
    LogTabPanelModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatSnackBarModule,
    MatTabsModule,
    MatTooltipModule,
    MaximizeDialogButtonModule,
    PreventDefaultModule,
    ProjectAvatarModule,
    RouterModule,
    SwitchBoardModule,
    TargetAvatarModule
  ],
  exports: [
    BuildProfileDialogComponent
  ]
})
export class BuildProfileDialogModule { }
